import { Directive, DestroyRef, Input, OnInit, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthenticationService } from '../../core/services/authentication.service';

@Directive({
  selector: '[adfHasRole]',
})
export class HasRoleDirective implements OnInit {
  private readonly _templateRef = inject(TemplateRef<unknown>);
  private readonly _viewContainer = inject(ViewContainerRef);
  private readonly _authService = inject(AuthenticationService);
  private readonly _destroyRef = inject(DestroyRef);

  private _roleNames: string[] = [];
  private _hasView = false;

  @Input()
  set adfHasRole(roleName: string | string[]) {
    this._roleNames = Array.isArray(roleName) ? roleName : [roleName];
    this._updateView();
  }

  ngOnInit(): void {
    this._authService.appUser$.pipe(takeUntilDestroyed(this._destroyRef)).subscribe(() => {
      this._updateView();
    });
  }

  private _updateView(): void {
    const shouldShow = this._roleNames.some((roleName) => this._authService.isUserInRole(roleName));

    if (shouldShow && !this._hasView) {
      this._viewContainer.createEmbeddedView(this._templateRef);
      this._hasView = true;
    } else if (!shouldShow && this._hasView) {
      this._viewContainer.clear();
      this._hasView = false;
    }
  }
}
